import i18next from 'i18next'
import { z } from 'zod'

import { SelectOptionZod, selectOptionZod } from 'components/Select'
import { userWorkspaceRoles } from 'features/user/types/userWorkspaceRole'
import { WorkspaceSlice } from '../../hooks/useGetWorkspaceOptions'

export const commonSchema = z.object({
  role: z.enum(userWorkspaceRoles),
  userId: z.string(),
  workspaceId: selectOptionZod<WorkspaceSlice>().refine(
    (value: SelectOptionZod<WorkspaceSlice>): boolean => value.value !== '',
    i18next.t('common:form.error.nonEmpty'),
  ),
})

export type CommonSchema = z.infer<typeof commonSchema>
